import * as Types from './types';
import { actionTypes } from './constants';
import { TJackpots, IJackpot } from '../types';

export const setJackpots = (jackpots: TJackpots): Types.ISetJackpotsAction => ({
    type: actionTypes.SET_JACKPOTS,
    payload: jackpots
});

export const setTotalCasinoJackpot = (casinoJackpot: IJackpot): Types.ISetTotalCasinoJackpotAction => ({
    type: actionTypes.SET_TOTAL_CASINO_JACKPOT,
    payload: casinoJackpot
});

export const clearJackpots = (): Types.IClearJackpotsAction => ({
    type: actionTypes.CLEAR_JACKPOTS
});
